import React from 'react';
import PageTitle from '../PageTitle';
import SectionTestimonials from '../Section.Testimonials';
import { Helmet } from 'react-helmet';

const MeetTheTeam = () => {
  return (
    <>
      <Helmet>
        <title>I'm Your Huckleberry | Meet the Team</title>
      </Helmet>
      <PageTitle title={'Meet the Team'} />
      <section className="w-100 py-5 bg-light">
        <div className="container">
          {/* Katie Section */}
          <div className="row align-items-center p-3 text-center">
            {/* Image Column - Mobile First */}
            <div className="col-md-6 order-1 order-md-2">
              <img
                src="/images/katie.webp"
                alt="Katie Hartman"
                className="img-fluid rounded shadow team-img"
              />
            </div>

            {/* Text Column */}
            <div className="col-md-6 order-2 order-md-1 mb-4 mb-md-0 d-flex align-items-center text-center">
              <div className="w-75 mx-auto">
                <h4 className="mb-2 pt-3 pt-md-0">Katie Hartman</h4>
                <h5>Owner/Operator & Cleaning Specialist</h5>
                <p className="mb-4">
                  Born and raised in Cumberland, WI, she's always called this area home. After
                  graduating from Barron High School in 2005 and earning her Bachelor’s Degree from
                  UW-River Falls in 2010, she returned to Cumberland with her husband, Austin, to
                  raise their two boys, Aiden and Declan. What started as a side hustle in 2015
                  quickly grew into a full-time passion for helping people enjoy cleaner, more
                  comfortable spaces. In 2020, she founded I'm Your Huckleberry LLC, and since then,
                  she's been proud to serve her community with reliable, high-quality residential
                  and commercial cleaning services. On the weekends, you might find her out and
                  about at her boys' sporting events, enjoying good food from local places, or out
                  hiking trails with her family and their two dogs.
                </p>
              </div>
            </div>
          </div>

          {/* Kallie Section */}
          <div className="row align-items-center p-3 text-center">
            {/* Image Column - Mobile First */}
            <div className="col-md-6 order-1 order-md-1">
              <img
                src="/images/kallie.webp"
                alt="Kallie Solie"
                className="img-fluid rounded shadow team-img"
              />
            </div>

            {/* Text Column */}
            <div className="col-md-6 order-2 order-md-2 mb-4 mb-md-0 d-flex align-items-center text-center">
              <div className="w-75 mx-auto">
                <h4 className="mb-2 pt-3 pt-md-0">Kallie Solie</h4>
                <h5>Cleaning Specialist</h5>
                <p className="mb-4">
                  Being a native to Chetek, Wisconsin, Kallie went from skipping up and down the
                  main drag of town to graduating from Chetek High School in 2009. Having a passion
                  for cleaning and organizing since she was 8 years old has led to her fulfilling
                  her dream and passion to become a professional cleaner in the surrounding area,
                  where she resides with her husband (Shawn) and three kids (Isaac, Bella, &
                  Kolton). On the weekends, you may find her on the sidelines of her kid's sporting
                  events or at home in the kitchen, baking her homemade chocolate cake for everyone
                  to enjoy!
                </p>
              </div>
            </div>
          </div>

          {/* Chelsea Section */}
          <div className="row align-items-center p-3 text-center">
            {/* Image Column - Mobile First */}
            <div className="col-md-6 order-1 order-md-2">
              <img
                src="/images/chelsea.jpg"
                alt="Chelsea Beneke"
                className="img-fluid rounded shadow team-img"
              />
            </div>

            {/* Text Column */}
            <div className="col-md-6 order-2 order-md-1 mb-4 mb-md-0 d-flex align-items-center text-center">
              <div className="w-75 mx-auto">
                <h4 className="mb-2 pt-3 pt-md-0">Chelsea Beneke</h4>
                <h5>Cleaning Specialist</h5>
                <p className="mb-4">
                  As a former apartment complex manager, Chelsea developed a strong understanding of
                  the importance of attention to detail, consistency, and treating each home as a
                  unique space. Now working as a cleaning specialist and raising two boys, she
                  appreciates how a clean, comfortable home can ease the stress of busy family life.
                  She takes pride in being dependable, thorough, and easy to communicate with.
                  Outside of work, she enjoys reading, creative crocheting, spending time with her
                  children, and caring for her chickens. She is genuinely committed to helping
                  clients maintain homes that feel fresh, cozy, and well cared for.
                </p>
              </div>
            </div>
          </div>

          {/* Chrissy Section */}
          <div className="row align-items-center p-3 text-center">
            {/* Image Column - Mobile First */}
            <div className="col-md-6 order-1 order-md-1">
              <img
                src="/images/chrissy.png"
                alt="Chrissy Roach"
                className="img-fluid rounded shadow team-img"
              />
            </div>

            {/* Text Column */}
            <div className="col-md-6 order-2 order-md-1 mb-4 mb-md-0 d-flex align-items-center text-center">
              <div className="w-75 mx-auto">
                <h4 className="mb-2 pt-3 pt-md-0">Chrissy Roach</h4>
                <h5>Cleaning Specialist</h5>
                <p className="mb-4">
                  As the oldest sister and a nanny for eight
                  years, I' ve always found myself in a
                  caregiving role. I love being able to help
                  others and make their day a little easier.

                  Cleaning is another way I enjoy showing up
                  for people. Theres something so satisfying
                  about checking things off a to-do list, and I
                  know how much coming home to a clean
                  space can help set the tone for the day-or week-ahead.

                  When I'm not cleaning you can usually find
                  me gardening, camping, fishing, or curled
                  up with a good book1! I'm excited to bring that helping hand into my clients' homes and give them one less thing to worry about!
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <SectionTestimonials />
    </>
  );
};

export default MeetTheTeam;
